import { useSearchInput } from './hooks/useSearchInput';
import { useFilters } from './hooks/useFilters';
import { useUI } from './hooks/useUI';
import { useUtils } from './hooks/useUtils';
import { SearchFormState, SearchFormActions } from './types';

export const useSearchForm = (): SearchFormState & SearchFormActions => {
  // Hooks específicos
  const searchInput = useSearchInput();
  const filters = useFilters();
  const ui = useUI();
  const utils = useUtils();

  // Handlers que combinan lógica de múltiples hooks
  const selectSearchResult = (ev: React.MouseEvent, res: any) => {
    const result = searchInput.selectSearchResult(ev, res, (serviceKey: string) => {
      filters.selectService(serviceKey, () => {
        ui.openList();
      });
    });
    if (result) {
      ui.setSelectedItem(result);
    }
  };

  const selectPopulation = (name: string) => {
    filters.selectPopulation(name, () => {
      // No abrir lista automáticamente, solo aplicar filtro
    });
  };

  const selectService = (name: string) => {
    filters.selectService(name, () => {
      // No abrir lista automáticamente, solo aplicar filtro
    });
  };

  const selectDays = (day: string) => {
    filters.selectDays(day, () => {
      // No abrir lista automáticamente, solo aplicar filtro
    });
  };

  const clearFilters = () => {
    filters.clearFilters(() => {
      ui.openList();
    });
  };

  const openList = () => {
    // Si no hay filtros aplicados, limpiar filtros para mostrar todos los centros
    if (filters.populationFilter.length === 0 && filters.serviceFilter.length === 0 && filters.daysFilter.length === 0) {
      filters.clearFilters(() => {
        ui.openList();
      });
    } else {
      ui.openList();
    }
  };

  return {
    // Estado
    item: ui.item,
    isListOpen: ui.isListOpen,
    isSearchResultOpen: searchInput.isSearchResultOpen,
    isFiltersOpen: ui.isFiltersOpen,
    isItemDetailOpen: ui.isItemDetailOpen,
    minimizeViewMobile: ui.minimizeViewMobile,
    isAdvancedFiltersExpanded: ui.isAdvancedFiltersExpanded,
    daysFilter: filters.daysFilter,
    populationFilter: filters.populationFilter,
    serviceFilter: filters.serviceFilter,
    searchInput: searchInput.searchInput,
    searchResult: searchInput.searchResult,
    noSearchResult: searchInput.noSearchResult,
    hasResults: ui.hasResults,

    // Acciones
    hideSearchResults: searchInput.hideSearchResults,
    toggleMinimizeViewMobile: ui.toggleMinimizeViewMobile,
    closeMinimizeViewMobile: ui.closeMinimizeViewMobile,
    toggleFilter: ui.toggleFilter,
    toggleAdvancedFilters: ui.toggleAdvancedFilters,
    openList,
    closeList: ui.closeList,
    openItemDetail: ui.openItemDetail,
    closeItemDetail: ui.closeItemDetail,
    goHome: ui.goHome,
    onSearch: searchInput.onSearch,
    selectSearchResult,
    clearInput: searchInput.clearInput,
    clearFilters,
    selectPopulation,
    selectService,
    selectDays,
    applyFilter: filters.applyFilter,
    setSelectedItem: ui.setSelectedItem,
    generatePdf: utils.generatePdf,
    copyUrl: utils.copyUrl,
  };
};
